module.exports = __webpack_public_path__ + "img/pdf.3270df43.png";